import { VdsTab } from '@volt/volt-extended-components-react';
import styles from './Tab.module.scss';
import BadgeDot from '@cas/components/data-display/badge-dot/BadgeDot';

export interface TabProps {
  active: boolean;
  title: string;
  isDotted?: boolean;
  slot?: string;
  onClicked?: () => void;
  size?: 'small' | 'medium';
}

/**
 * FIXME: The 'isActive' prop has been deprecated, signalling the end of being able to use vds-tab as a standalone component.
 * vds-tabs-group is fundamentally inconsistent with our application requirements, so we will need to replace the vds-tab
 * component with a custom component.
 */
export const Tab = ({ active, title, isDotted, slot, onClicked, size = 'medium' }: TabProps) => {
  return (
    <VdsTab
      type="custom"
      isActive={active}
      slot={slot}
      onIsSelected={onClicked}
      className={`${styles.tab} ${styles[`tab--${size}`]}`}
    >
      <div slot="tab-header-content" className={styles.header}>
        <div
          className={`${styles.title} ${active && styles['title--active']} ${styles[`title--${size}`]}`}
        >
          {title}
        </div>
        {isDotted && <BadgeDot size={8} />}
      </div>
    </VdsTab>
  );
};

export default Tab;
